import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KindService {

  constructor(private httpClientService:HttpClientService) { }
  async getAllKinds(search,page,size,typeNumber){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Kind,
      queryString:`search=${search}&Page=${page}&Size=${size}&typeNumber=${typeNumber}`
    });
    return await firstValueFrom(observable);
  }

  async getAllKind(search,page,size){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Kind,
      queryString:`search=${search}&Page=${page}&Size=${size}`,
      action:"GetAllKinds"
    });
    return await firstValueFrom(observable);
  }

  async getByName(typeName:string){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Kind,
      action:"GetByNameType"
    },typeName);
    return await firstValueFrom(observable);
  }

  async createKind(kindName:string,kindNumber){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Kind,
    },{
      typeName:kindName,
      typeNumber:kindNumber
    });
    return await firstValueFrom(observable);
  }

  async updateKind(id,kindName:string,kindNumber){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.Kind,
    },{
      id:id,
      typeName:kindName,
      typeNumber:kindNumber
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
